module.exports = __webpack_public_path__ + "img/logo.73d7c6d3.svg";